import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ActionStatusComponent } from './action-status.component';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ButtonComponent } from '@personal-area/global/ui'
import { CardWrapperModule } from '@personal-area/global/ui';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule,
    ButtonComponent,
    CardWrapperModule
  ],
  exports: [ActionStatusComponent],
  declarations: [ActionStatusComponent],
  providers: [],
})
export class ActionStatusModule {
}
